import { render, staticRenderFns } from "./TalkCommentsLine.vue?vue&type=template&id=0b0ec571&scoped=true&"
import script from "./TalkCommentsLine.vue?vue&type=script&lang=js&"
export * from "./TalkCommentsLine.vue?vue&type=script&lang=js&"
import style0 from "./TalkCommentsLine.vue?vue&type=style&index=0&id=0b0ec571&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0ec571",
  null
  
)

export default component.exports